export const IconWatchUrgent20: {
  name: 'icon_watch_urgent_20-b7a45c1187ab'
} = {
  name: 'icon_watch_urgent_20-b7a45c1187ab'
}
